// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3P01_","title":"styles_title__1I7O5"};